<div class="d-flex flex-column flex-auto">
  <div class="bottombar-buttons">
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <div class="d-flex align-items-center group-info flex-auto">
          <span>{{'group_details.action_bar.group_name' | translate:{groupName: influencerGroup.influencer_group_name} }}</span>
        </div>
      </div>
      <div class="col-md-6 col-sm-6">
        <div class="d-flex flex-auto align-items-center justify-content-end">
          <div class="d-flex flex-row">
            <button class="button red back-button" (click)="openConfirmationBeforeExisting()">{{'common.btn.back' | translate}}</button>
            <button class="button green"
                    [disabled]="!canProceedNewInfluencer"
                    actionByLevels="Add influencer to group"
                    [wallName]="'Groups Disabled'"
                    (afterChecking)="validateInfluencerListBeforeAddToGroup()">
              {{'common.btn.add_to_group' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <achoo-placeholder placeholderId="addNewInfluencerPlaceholder" class="add-new-influencer-placeholder">
    <div class="bottombar-content add-influencer-content flex-auto">
      <div class="row flex-auto">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-12px">
          <div class="row">
            <div class="col-md-12 col-sm-12 mt-20px mb-10px">
              <span class="add-influencer-title">{{'group_details.add_influencer.title' | translate}}</span>
            </div>
          </div>
          <div class="d-flex flex-column flex-auto list-selected-influencer">
            <div class="full-width" *ngFor="let influencer of selectedInfluencers; let i = index">
              <div class="d-flex flex-row flex-auto">
                <div class="influencer-details">
                  <div class="selected-influencer-line">
                    <div class="d-flex flex-row flex-auto influencer-content">
                      <div class="influencer-handle">
                        {{getChannels(influencer)}}
                      </div>
                      <div class="influencer-name-country d-flex">
                        <div class="d-flex flex-row" *ngIf="!isUnknownInfluencer(influencer)">
                          <span class="influencer-name">- {{influencer.influencerName}}</span>
                          <div class="flag-icon-background flag-icon-{{getCountryCode(influencer)}} flag-icon-squared img-circle"></div>
                        </div>

                        <div class="d-flex flex-row" *ngIf="isUnknownInfluencer(influencer)">
                          <img src="/assets/images/Warning_Icon.svg" class="unknown-influencer-icon">
                          <span class="ml-8px">{{'common.new_influencer' | translate}}</span>
                        </div>
                      </div>
                      <div class="influencer-platforms">
                        <status-influencer-suggestion [index]="i"
                                                      [handle]="getChannels(influencer)"
                                                      [influencer]="influencer"
                                                      (addNewInfluencerManuallyEvent)="addNewInfluencer($event)"
                                                      (retryAfterErrorEvent)="retryWhenErrorOccurred($event)"
                                                      (showMultipleSelectionEvent)="openMultipleHandleSelection($event)">
                        </status-influencer-suggestion>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end remove-selected-icon-container">
                  <a (click)="removeInfluencer(influencer.influencerId, influencer.influencerName)" class="d-flex button-icon">
                    <img src="/assets/images/Trash_Icon.svg" class="icon-trash-add-influencer">
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-9px">
            <div class="col-md-12 col-sm-12">
              <auto-suggestion-influencer #autoSuggestionInfluencer
                                          [numberSelectedInfluencer]="selectedInfluencers.length"
                                          (selectInfluencerEvent)="selectInfluencerSuggestion($event)"
                                          (afterLoadingSuggestion)="afterSearchingInfluencer($event)"
                                          (addNewInfluencer)="selectAndAddNewInfluencer($event)"
                                          (enterEvent)="onEnterInfluencer($event)">
              </auto-suggestion-influencer>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div class="send-to-review-box">
            <send-to-review #AddInfluencerForReview (changeReviewerEvent)="onChangeSelectedReviewers($event)"></send-to-review>
            <bulk-upload-influencer [influencerGroup]="influencerGroup"
                                    [hasSelectedInfluencers]="hasSelectedInfluencers"
                                    (closeBottomBarCallback)="closeWithoutSaving($event)">
            </bulk-upload-influencer>
          </div>
        </div>
      </div>
    </div>
  </achoo-placeholder>
</div>
<achoo-popup #WarningInfluencerAlreadyExistOtherGroup
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <div class="d-flex flex-column flex-auto">
    <span>{{errorMessage}}</span>
  </div>
</achoo-popup>
<achoo-popup #ConfirmationBeforeCloseAddInfluencer
             cancelBtnLabel="{{'add_influencer_manually.cancel_button' | translate }}"
             acceptBtnLabel="{{'add_influencer_manually.confirm_accept_button' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="closeWithoutSaving()"
             (cancelCallback)="closeConfirmationPopup()">
  <span>{{'add_influencer_manually.confirmation_message' | translate}}</span>
</achoo-popup>
<achoo-popup #WarningBeforeAddNewInfluencer
             cancelBtnLabel="{{'common.btn.cancel' | translate }}"
             acceptBtnLabel="{{'common.btn.ok' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="closeConfirmationPopup()"
             (cancelCallback)="closeConfirmationPopup()">
  <span>{{'add_influencer_manually.warning_message' | translate}}</span>
</achoo-popup>




// WEBPACK FOOTER //
// ./src/app/main/group-details/add-influencer-group/add-influencer-group.component.html